import React, { useEffect, useRef, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CarouselCards.css";

const imageUrls = [
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709514/1H7A9812_nfojyp.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780598206/DIana_STudio-1-2_yi00yw.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709522/2022-07-12_18-41-17_040_2023-11-01T06_07_04.132_maebkj.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780733921/1H7A3997-1_dyktar.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709527/1H7A7373_x11jfc.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780734103/1234_zpwj58.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709498/1H7A3280_guukgu.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780734105/12345_rbjzjj.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709487/1H7A0484_ji2hgk.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780734108/123_kghh9n.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709486/1H7A9218_bo3ugp.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709482/1H7A0240_xblqxf.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715712524/1H7A3816_vdtdvr.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709549/_MG_8493_geo9nx.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709544/IMG_3673_dywark.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709514/1H7A5750_wgomv5.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1715709555/post_2_uu1eq4.png",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780734607/Senza_titolo-3-1_ehkd7o.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780735091/1H7A5846-1_fyuhjn.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780735092/1H7A7391-1_mjyush.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780735106/Senza_titolo-1_pzueo4.jpg",
  "https://res.cloudinary.com/dtem45qog/image/upload/v1780735780/Senza_titolo-1_znksjh.jpg",
];

// Ottimizzazione estrema: larghezza fissa a 600px, qualità compressa (eco), conversione formato
const optimizeImageUrl = (url) => {
  return url
    .trim()
    .replace("/image/upload/", "/image/upload/c_scale,w_600,q_auto:eco,f_auto/");
};

const shuffleArray = (arr) => {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const getCardsPerSlide = (width) => {
  if (width >= 1400) return 4;
  if (width >= 1200) return 3;
  if (width >= 768) return 2;
  return 1;
};

const CarouselCards = () => {
  const carouselRef = useRef(null);
  const [cardsPerSlide, setCardsPerSlide] = useState(
    getCardsPerSlide(window.innerWidth),
  );
  const shuffledImages = useMemo(() => shuffleArray(imageUrls), []);

  useEffect(() => {
    const handleResize = () =>
      setCardsPerSlide(getCardsPerSlide(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const groupedImages = [];
  for (let i = 0; i < shuffledImages.length; i += cardsPerSlide) {
    groupedImages.push(shuffledImages.slice(i, i + cardsPerSlide));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const nextBtn = carouselRef.current?.querySelector(
        ".carousel-control-next",
      );
      nextBtn?.click();
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="port py-5">
      <div id="Port" className="container mt-4">
        <h2 className="text-center mb-4">Portfolio</h2>
        <div id="carouselCards" className="carousel slide" ref={carouselRef}>
          <div className="carousel-inner">
            {groupedImages.map((group, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <div className="row bg-transparent justify-content-center">
                  {group.map((src, idx) => (
                    <div
                      key={idx}
                      className="col-xxl-3 col-xl-4 col-md-6 col-sm-12"
                    >
                      <div className="card mb-3 border-0 bg-transparent">
                        <div className="image-wrapper">
                          <img
                            src={optimizeImageUrl(src)}
                            alt={`Immagine ${idx + 1}`}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                            // Il primo gruppo di slide si carica subito (eager), 
                            // tutti i successivi aspettano in background (lazy)
                            loading={index === 0 ? "eager" : "lazy"} 
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev d-none"
            type="button"
            data-bs-target="#carouselCards"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" />
          </button>
          <button
            className="carousel-control-next d-none"
            type="button"
            data-bs-target="#carouselCards"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselCards;